import React, { useState } from "react";
import { useQuery } from "react-apollo-hooks";
import { STORE_LIST_QUERY } from "./Queries";
import AsyncSelect from "react-select/async";

export default ({ store, setStore }) => {
  const [keyword, setKeyword] = useState("");
  const { data, loading } = useQuery(STORE_LIST_QUERY, {
    variables: { keyword, skip: 0, first: 10 },
  });

  const loadOptions = (inputValue, callback) => {
    if (!loading) {
      const options = data.AdminStoreList.stores.map((item) => {
        return {
          value: item.id,
          label: item.name,
          // 위치 검증은 좌표가 있어야 켤 수 있어 선택 시점에 함께 넘긴다.
          hasLocation: !!(item.longitude && item.latitude),
        };
      });

      callback(options);
    }
  };
  const handleInputChange = (value) => {
    setTimeout(() => {
      setKeyword(value);
      return value;
    }, 500);
  };

  return (
    <AsyncSelect
      name="store"
      placeholder="가맹점명 입력"
      noOptionsMessage={() => {
        return "가맹점명을 검색해주세요.";
      }}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={(option) => {
        setStore(option || "");
      }}
      isClearable
      defaultValue={store || null}
    />
  );
};
